export default "__VITE_ASSET__17aafdea__"